import { Grid } from "@mui/material";
import ThemeContext from "components/app/Context";
import { useContext } from "react";
import { planTypes } from "utils/Types";

interface Props {
  type: string;
  children: any;
}

function PlanCard(props: Props) {
  const { type, children } = props;
  const { isMobileScreen } = useContext(ThemeContext);

  return (
    <Grid
      container
      spacing={2}
      className="action-card"
      sx={{
        margin: isMobileScreen ? "8px 0" : "16px 0",
        padding: type === planTypes.MyPlans ? "8px 24px 24px 8px" : "0",
        alignItems: type === planTypes.MyPlans ? "center" : "stretch",
        justifyContent: "space-between",
        backgroundColor: "#fff",
        width: "100%",
        borderRadius: "12px",
        ":hover": {
          boxShadow: "0px 10px 25px rgba(100, 116, 139, 0.1), 0px 20px 40px 8px rgba(100, 116, 139, 0.3)"
        }
      }}
    >
      {children}
    </Grid>
  );
}

export default PlanCard;
